import React, { useState } from "react";
import Table from "../../../core/common/dataTable/index";
import { Link } from "react-router-dom";
import ImagePreviewModal from "../imageView/ImagePreviewModal";

const DisbursementDetails = ({ allDisbursementData }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleImageClick = (imgUrl: string) => {
    setSelectedImage(imgUrl);
    setShowImageModal(true);
  };

  type DisbursementData = {
    key: string;
    srNo: string;
    Status: string;
    id: number | string;
    amount?: string;
    disbursement_date?: string;
    file_charges?: string;
    other_charges?: string;
    start_date?: string;
    type?: string;
    utrImageUrl?: string;
    utrNumber?: string;
    allData?: any;
  };

  const column = [
    {
      title: "Sr. No.",
      dataIndex: "srNo",
    },
    {
      title: "Loan Account Number",
      dataIndex: "amount",
      render: (_: any, record: DisbursementData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.allData.loans.loan_id || "--"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Disbursement Date",
      dataIndex: "disbursement_date",
      sorter: (a: DisbursementData, b: DisbursementData) =>
        new Date(a.disbursement_date || "").getTime() -
        new Date(b.disbursement_date || "").getTime(),
    },
    {
      title: "Disbursement Amount",
      dataIndex: "amount",
      render: (_: any, record: DisbursementData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.amount || "--"}</p>
          </div>
        </div>
      ),
    },
    {
      title: "UTRN Number",
      dataIndex: "amount",
      render: (_: any, record: DisbursementData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.utrNumber || "--"}</p>
          </div>
        </div>
      ),
    },
    {
      title: "UTRN Image",
      dataIndex: "amount",
      render: (_: any, record: DisbursementData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <img
              src={record.utrImageUrl}
              alt="UTRN Icon"
              className="me-2"
              style={{ width: "20px", height: "20px", objectFit: "cover" }}
              onClick={() => handleImageClick(record.utrImageUrl)}
            />
          </div>
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (_: any, record: DisbursementData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.type || "--"}</p>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="modal fade" id="disburse_details">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h4 className="modal-title me-2">All Disbursements</h4>
            </div>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="card-body p-0 theme_new_color">
            {allDisbursementData && allDisbursementData.length > 0 && (
              <Table
                dataSource={allDisbursementData}
                columns={column}
                Selection={true}
              />
            )}
          </div>
        </div>
      </div>
      <ImagePreviewModal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        imageUrl={selectedImage}
      />
    </div>
  );
};

export default DisbursementDetails;
